import type { TRootState } from 'core/store/reducers';

export const addressesSelector = (state: TRootState) => state.addresses;
export const addressesLoadingSelector = (state: TRootState) => state.addresses.loading;
export const addressesDataSelector = (state: TRootState) => state.addresses.addresses;
